import { render, staticRenderFns } from "./Kasko.vue?vue&type=template&id=3b0dffd1&"
import script from "./Kasko.vue?vue&type=script&lang=js&"
export * from "./Kasko.vue?vue&type=script&lang=js&"
import style0 from "./Kasko.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports